export const SUBSTATION_COLOR = "#ff4647";

export const SUBSTATION_PROPERTY_TYPE = "park-substation";
export const EXPORT_CABLE_PROPERTY_TYPE = "park-external-wiring";
export const CABLE_PROPERTY_TYPE = "park-wiring-connection";
export const CABLE_CORRIDOR_PROPERTY_TYPE = "park-cable-corridor";
